module.exports = __webpack_public_path__ + "static/media/title.ff0009a9.png";